function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M36.099 6.231C52.362 8.672 66.656 30.135 63.58 45.973a18.852 18.852 0 01-3.357 7.748 18.61 18.61 0 01-3.286 3.396c-5.16 4.148-12.877.338-23.611-.963-11.727-1.412-20.188 5.463-26.7-1.5A20.753 20.753 0 013.485 50.3C1.004 45.706.496 40.486 1.45 35.282 4.326 19.53 20.601 3.906 36.1 6.23z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.438 39v9.117",
  stroke: "#1FA956",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.438 17.5v28.804",
  stroke: "#FFDB00",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M53.438 7.5v39.494",
  stroke: "#53C0DA",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.438 34v13.1",
  stroke: "#EC7EB0",
  strokeWidth: 6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgImgOutcomes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4yIiBkPSJNMzYuMDk4NiA2LjIzMTA0QzUyLjM2MjMgOC42NzIxIDY2LjY1NjQgMzAuMTM1NSA2My41OCA0NS45NzI4QzYzLjA2ODIgNDguNzYwMyA2MS45MjIzIDUxLjQwNSA2MC4yMjMyIDUzLjcyMDlDNTkuMjgyOSA1NC45ODE0IDU4LjE3ODcgNTYuMTIyNCA1Ni45MzY5IDU3LjExNjlDNTEuNzc3MiA2MS4yNjUgNDQuMDYwNCA1Ny40NTUxIDMzLjMyNTkgNTYuMTU0NEMyMS41OTg2IDU0Ljc0MjQgMTMuMTM3NyA2MS42MTc0IDYuNjI2NTEgNTQuNjU0M0M1LjM4ODQ1IDUzLjMzNjIgNC4zMzIyMyA1MS44NzI0IDMuNDgzNzEgNTAuMjk5QzEuMDA0MjcgNDUuNzA1NyAwLjQ5NjEwMiA0MC40ODU4IDEuNDUxMzUgMzUuMjgxN0M0LjMyNTg0IDE5LjUyOTUgMjAuNjAxMSAzLjkwNTY2IDM2LjA5ODYgNi4yMzEwNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNC40Mzc1IDM5VjQ4LjExNzIiIHN0cm9rZT0iIzFGQTk1NiIgc3Ryb2tlLXdpZHRoPSI2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQwLjQzNzUgMTcuNUw0MC40Mzc1IDQ2LjMwNDMiIHN0cm9rZT0iI0ZGREIwMCIgc3Ryb2tlLXdpZHRoPSI2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUzLjQzNzYgNy41TDUzLjQzNzUgNDYuOTk0MyIgc3Ryb2tlPSIjNTNDMERBIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuNDM3NSAzNFY0Ny4wOTk5IiBzdHJva2U9IiNFQzdFQjAiIHN0cm9rZS13aWR0aD0iNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgImgOutcomes as ReactComponent };